import { render, staticRenderFns } from "./RegionHeader.vue?vue&type=template&id=37daa4f4&scoped=true&"
import script from "./RegionHeader.vue?vue&type=script&lang=js&"
export * from "./RegionHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegionHeader.vue?vue&type=style&index=0&id=37daa4f4&prod&lang=scss&scoped=true&"
import style1 from "./RegionHeader.vue?vue&type=style&index=1&id=37daa4f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37daa4f4",
  null
  
)

export default component.exports